import FormHelper from 'components/Form/Common/FormHelper';
import FormLabel from 'components/Form/Common/FormLabel';
import React, { useState } from 'react';
import { FieldError } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Colors } from 'styles/theme';
import { JRCTooltipProps } from 'types';
import { JRCFormErrors } from '../Common/JRCFormErrors';
import { StyledDescription } from '../Deprecated/JRCFormFieldRender';
import { InputTextRawStyled, LabelWrapper, Required, StyledFieldWrapper } from './JRCInputTextRaw.style';

export type JRCInputTextRawProps = React.ComponentPropsWithoutRef<'input'> & {
    margin?: string | undefined;
    width?: string | undefined;
    readOnly?: boolean;
    disabled?: boolean;
    isRequired?: boolean;
    label?: string;
    htmlFor?: string;
    labelIsLegend?: boolean;
    description?: string;
    helper?: Omit<JRCTooltipProps, 'children'>;
    errors?: FieldError;
    customRef?: React.Ref<HTMLInputElement>;
};

const RenderInputElement = (props: JRCInputTextRawProps, ref: React.ForwardedRef<HTMLInputElement>) => {
    return <InputTextRawStyled type="text" id={props.name} {...props} ref={ref} />;
};
export const RenderInput = React.forwardRef(RenderInputElement);

export function JRCInputTextRaw(props: JRCInputTextRawProps) {
    const intl = useIntl();
    const [helperColor, setHelperColor] = useState<Colors>('grey3');
    const colorHelperIcon = (event: boolean) => setHelperColor(event ? 'yellow' : 'grey3');

    function isRequiredInvalid() {
        return !!(
            (props.isRequired && props.value === undefined) ||
            props.value === null ||
            props.value === '' ||
            (Array.isArray(props.value) && !props.value.length)
        );
    }

    return (
        <StyledFieldWrapper className={props.className} margin={props.margin} width={props.width}>
            {(props.label || props.helper || props.description || (props.isRequired && !props.readOnly)) && (
                <FormLabel htmlFor={props.htmlFor || props.name} labelIsLegend={props.labelIsLegend}>
                    <LabelWrapper>
                        <div>
                            {props.label && props.label}
                            {props.helper && <FormHelper tooltip={props.helper} color={helperColor} />}
                            {props.description && <StyledDescription>{props.description}</StyledDescription>}
                        </div>
                        {props.isRequired && !props.readOnly && (
                            <Required error={isRequiredInvalid()}>
                                {intl.formatMessage({ id: 'GLOBAL_Form_Controls_Required' })}
                            </Required>
                        )}
                    </LabelWrapper>
                </FormLabel>
            )}
            <div className="input-wrapper" onFocus={() => colorHelperIcon(true)} onBlur={() => colorHelperIcon(false)}>
                <RenderInput {...props} ref={props.customRef} />
            </div>
            <JRCFormErrors error={props.errors} />
        </StyledFieldWrapper>
    );
}
